import * as React from 'react';

function SvgLogo(props) {
  return (
    <svg
      width={32}
      height={33}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.485}
        y={0.486}
        width={31.03}
        height={31.122}
        rx={9.641}
        fill="url(#Logo_svg__paint0_linear_25_6057)"
      />
      <rect
        x={0.686}
        y={0.687}
        width={30.629}
        height={30.72}
        rx={9.44}
        stroke="#FDF3F3"
        strokeOpacity={0.06}
        strokeWidth={0.402}
      />
      <g filter="url(#Logo_svg__filter0_d_25_6057)">
        <rect
          x={7.959}
          y={8.125}
          width={5.769}
          height={15.913}
          rx={2.885}
          fill="url(#Logo_svg__paint1_linear_25_6057)"
        />
      </g>
      <path
        d="M24.01 23.102V17.85c0-.578-.469-1.047-1.047-1.047h-5.671c-.616 0-1.105.534-.98 1.137.91 4.362 4.465 5.984 6.797 6.103.519.026.9-.421.9-.94z"
        fill="url(#Logo_svg__paint2_linear_25_6057)"
      />
      <ellipse
        cx={20.665}
        cy={11.466}
        rx={3.332}
        ry={3.342}
        fill="url(#Logo_svg__paint3_linear_25_6057)"
      />
      <rect
        x={0.52}
        y={0.52}
        width={30.96}
        height={31.055}
        rx={9.791}
        stroke="url(#Logo_svg__paint4_linear_25_6057)"
        strokeWidth={1.04}
      />
      <defs>
        <linearGradient
          id="Logo_svg__paint0_linear_25_6057"
          x1={16}
          y1={0.486}
          x2={16}
          y2={31.608}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222527" />
          <stop offset={1} stopColor="#131415" />
        </linearGradient>
        <linearGradient
          id="Logo_svg__paint1_linear_25_6057"
          x1={9.685}
          y1={10.691}
          x2={12.734}
          y2={21.625}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAECEB" />
          <stop offset={1} stopColor="#D9E9EE" />
        </linearGradient>
        <linearGradient
          id="Logo_svg__paint2_linear_25_6057"
          x1={20.077}
          y1={16.803}
          x2={20.077}
          y2={24.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFF5F3" />
          <stop offset={1} stopColor="#BBF2EF" />
        </linearGradient>
        <linearGradient
          id="Logo_svg__paint3_linear_25_6057"
          x1={20.665}
          y1={8.125}
          x2={20.665}
          y2={14.808}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8F76" />
          <stop offset={1} stopColor="#EB4A27" />
        </linearGradient>
        <linearGradient
          id="Logo_svg__paint4_linear_25_6057"
          x1={16}
          y1={0}
          x2={16}
          y2={32.095}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCFCF6" />
          <stop offset={1} stopColor="#8FA1DF" />
        </linearGradient>
        <filter
          id="Logo_svg__filter0_d_25_6057"
          x={7.793}
          y={8.026}
          width={6.101}
          height={16.245}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.066} />
          <feGaussianBlur stdDeviation={0.083} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_25_6057"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_25_6057"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgLogo;
